export default __webpack_public_path__ + "static/media/icon_information_circle_20_grey.d56001fa.svg";